import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import minifyTheme from 'minify-css-string'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: !!(localStorage.getItem('dark_theme') * 1) || false,
    themes: {
      light: {
        primary: '#449afd',
        navigation: '#0f172a',
      },
      dark: {
        primary: '#449afd',
        navigation: '#0f172a',
      },
    },
    options: {
      customProperties: true,
      minifyTheme,
    },
  },
  breakpoint: {
    thresholds: {
      xs: 768,
      sm: 1024,
      md: 1280,
      lg: 1400,
    },
    mobileBreakpoint: 'sm',
  },
  icons: {
    iconfont: 'mdiSvg',
  },
})
